import React, { Component } from 'react';

// Components
import TableCell from './TableCell';

class SkillsAndCompetencyTable extends Component {
    constructor(props) {
        super(props);

        this.rows = ['', 
            'Startup & Innovation', 
            'Energy & Utilities', 
            'Consumer Products & Retail', 
            'Financial Services',
            'Automotive & Transport', 
            'Govt. & Public Sector', 
            'Life Sciences', 
            'Media & Entertainment'
        ];
        this.columns = ['',
            'UX Design',
            'UI Design',
            'Social Media',
            'Branding',
            'PR/Marketing',
            'Project Management',
            'Photo/Video',
            'Copywriting'
        ];

        this.state = {
            exp1: [],
            exp2: [],
            exp3: [],
            exp4: [],
            exp5: [],
            exp6: [],
            exp7: [],
            exp8: [],
            numberOfSelectedCols: 0
        };

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(row, col, selected) {
        let expValue = this.state['exp' + row];
        let oldSelectedNumber = this.state.numberOfSelectedCols;
        if (selected) {
            expValue.push(col);
            oldSelectedNumber++;
        } else {
            const index = expValue.indexOf(col);
            expValue.splice(index, 1);
            oldSelectedNumber--;
        }

        this.setState(
            {
                ['exp' + row]: expValue, numberOfSelectedCols: oldSelectedNumber
            },
            () => this.props.input.onChange(this.state)
        );
    }

    render() {
        return (
            <div className="forCheckSec">
                <div className="forScorll">
                    <div className="tabel text-center">
                        {this.rows.map((row, rowIndex) => (
                            <div key={rowIndex} className="tabelRow">
                                {this.columns.map((col, colIndex) => (
                                    <div key={rowIndex+colIndex} className="tabelCell">
                                        <TableCell
                                            row={row}
                                            rowIndex={rowIndex}
                                            col={col}
                                            colIndex={colIndex}
                                            onSelect={() => this.handleClick(rowIndex, colIndex, true)}
                                            onUnselect={() => this.handleClick(rowIndex, colIndex, false)}/>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="forNext">
                    <button type="button"
                            disabled={this.state.numberOfSelectedCols === 0}
                            onClick={() => this.props.custom.onClickNext()}
                            name="button" className="btn btn-danger text-uppercase">
                        next
                    </button>
                </div>
            </div>
        );
    }
}

export default SkillsAndCompetencyTable;



// WEBPACK FOOTER //
// ./src/components/Membership/Step1/Skils&CompetencyTable/index.js